import { Popover } from '@mui/material';
import { CitationPopoverProps } from './CitationPopover.props';
import CitationCard from '../../Cards/citation-card/CitationCard';

const CitationPopover = ({ citation, columnarIdentifier, onDelete, ...popoverProps }: CitationPopoverProps) => (
  <Popover
    {...popoverProps}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    disableRestoreFocus
    slotProps={{
      paper: {
        sx: {
          maxWidth: '400px',
          padding: 2,
        },
      },
    }}>
    <CitationCard citation={citation} identifier={columnarIdentifier} onDelete={onDelete} />
  </Popover>
);

export default CitationPopover;
